import { render, staticRenderFns } from "./RestorationAttachments.vue?vue&type=template&id=2af5652a&scoped=true&"
import script from "./RestorationAttachments.vue?vue&type=script&lang=js&"
export * from "./RestorationAttachments.vue?vue&type=script&lang=js&"
import style0 from "./RestorationAttachments.vue?vue&type=style&index=0&id=2af5652a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5652a",
  null
  
)

export default component.exports